export default __webpack_public_path__ + "static/bg-what-is-ml-0d31cb8c8afa9d64b553b3df45068883.webp";